import { useState } from 'react'
import { Grid, Button, Typography } from '@mui/material'

import { UrlIcon } from 'src/assets/icons'
import useStyles from './styles'
import { ProductOverrideUrlModal } from '../code-card'
import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  productId: string
  url: string | null
  lngCode: string
}

export const OverrideButton = ({ productId, url, lngCode }: IProps) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleClose = () => setOpen(false)

  const handleUpdateClick = () => setOpen(true)

  return (
    <>
      <Grid item>
        <Button
          startIcon={<UrlIcon className={classes.buttonIcon} />}
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={handleUpdateClick}
        >
          <Typography className={classes.buttonText}>
            <HelperWrapper t="override-button-text" />
          </Typography>
        </Button>
      </Grid>
      <ProductOverrideUrlModal
        url={url}
        productId={productId}
        onClose={handleClose}
        open={open}
        lngCode={lngCode}
      />
    </>
  )
}
